module.exports = __webpack_public_path__ + "static/media/ipd.501f4147.jpg";